import { deleteCubeBackupURL, deleteCubeRestoreURL, getAllCubeUrl, getCubeBackupURL, getCubeRestoreURL, getDcsUrl } from "../../../constants/urls";
import { REQUEST_METHOD_GET, allRequest, postRequest, deleteRequest } from "../../../middlewares/api/actions";

export const BACKUP_RESTORE_CUBE_TREE_READ = 'BACKUP_RESTORE_CUBE_TREE_READ';
export const BACKUP_RESTORE_CUBE_SELECTED = 'BACKUP_RESTORE_CUBE_SELECTED';
export const BACKUP_RESTORE_CUBE_CREATE_BACKUP = 'BACKUP_RESTORE_CUBE_CREATE_BACKUP';
export const BACKUP_RESTORE_CUBE_RESTORE = 'BACKUP_RESTORE_CUBE_RESTORE';
export const BACKUP_RESTORE_CUBE_DELETE_BACKUP = 'BACKUP_RESTORE_CUBE_DELETE_BACKUP';


export const getAllCubeBackupOrRestoreUrl = () => allRequest(
    BACKUP_RESTORE_CUBE_TREE_READ,
    [REQUEST_METHOD_GET,REQUEST_METHOD_GET],
    [getAllCubeUrl(true), getDcsUrl()]
)

export const seletedCubeBackupOrRestore = (cube) => ({
    type:BACKUP_RESTORE_CUBE_SELECTED,
    cube
})

export const createCubeBackup = (cubeId) => postRequest(
    BACKUP_RESTORE_CUBE_CREATE_BACKUP,
    getCubeBackupURL(cubeId),
    null,
    t => ({
        success: t('scenes.utilities.cubeBackupRestore.messages.createBackup.success')
    }),
)

export const getRestoreCube = (cubeId) => postRequest(
    BACKUP_RESTORE_CUBE_RESTORE,
    getCubeRestoreURL(cubeId),
    null,
    t => ({
        success: t('scenes.utilities.cubeBackupRestore.messages.restoreBackup.success')
    }),
)

export const deleteBackupCube = (cubeId) => deleteRequest(
    BACKUP_RESTORE_CUBE_DELETE_BACKUP,
    deleteCubeBackupURL(cubeId),
    t => ({
        success: t('scenes.utilities.cubeBackupRestore.messages.deleteBackup.success')
    }),
)